import { Effect } from '@comeon/ui';
import styled from 'styled-components';
import breakpoint from '../../../utils/style-utils';

interface Props {
	showSidebar: boolean;
}
// Values added to adapt for Splash Techs breakpoints and positions
const SPLASH_TECH_SMALLER_CLOSE_BUTTON_DIAMETER = 15;
const SPLASH_TECH_BIGGER_CLOSE_BUTTON_DIAMETER = 24;
const SPLASH_TECH_SMALLER_CLOSE_BUTTON_TOP_LEFT = 8;
const SPLASH_TECH_BREAKPOINT = 960;
const SPLASH_TECH_MAX_WIDTH = 1280;
const SPLASH_TECH_MULTIPLIER = 1.2;
const SPLASH_TECH_INNER_MULTIPLIER = 1.03;
const SPLASH_TECH_SIDEBAR_WIDTH = 375;
const SPLASH_TECH_BIGGER_CLOSE_BUTTON_TOP = 'calc(3.5% + 22px)';
const SPLASH_TECH_BIGGER_CLOSE_BUTTON_RIGHT = 'calc(3.5% + 12px)';

// Values added to adapt for Thunderbite breakpoints and positions
const THUNDERBITE_SMALLER_CLOSE_BUTTON_DIAMETER = 32;
const THUNDERBITE_BIGGER_CLOSE_BUTTON_DIAMETER = 48;
const THUNDERBITE_SMALLER_CLOSE_BUTTON_TOP_LEFT = 12;
const THUNDERBITE_BIGGER_CLOSE_BUTTON_TOP_LEFT = 24;

const calculateMinWidth = (props: Props): number =>
	props.showSidebar ? SPLASH_TECH_BREAKPOINT + SPLASH_TECH_SIDEBAR_WIDTH : SPLASH_TECH_BREAKPOINT;

const calculateMinWidthWithMultiplier = (props: Props): number =>
	props.showSidebar
		? SPLASH_TECH_MAX_WIDTH * SPLASH_TECH_MULTIPLIER * SPLASH_TECH_INNER_MULTIPLIER + SPLASH_TECH_SIDEBAR_WIDTH
		: SPLASH_TECH_MAX_WIDTH * SPLASH_TECH_MULTIPLIER * SPLASH_TECH_INNER_MULTIPLIER;

export const CloseButtonSplashtech = styled(Effect)<Props>`
	position: absolute;
	top: ${SPLASH_TECH_SMALLER_CLOSE_BUTTON_TOP_LEFT}px;
	left: ${SPLASH_TECH_SMALLER_CLOSE_BUTTON_TOP_LEFT}px;
	width: ${SPLASH_TECH_SMALLER_CLOSE_BUTTON_DIAMETER}px;
	height: ${SPLASH_TECH_SMALLER_CLOSE_BUTTON_DIAMETER}px;
	border-radius: 9999px;
	display: flex;
	justify-content: center;
	align-items: center;
	@media (min-width: ${props => `${calculateMinWidth(props)}px`}) {
		width: ${SPLASH_TECH_BIGGER_CLOSE_BUTTON_DIAMETER}px;
		height: ${SPLASH_TECH_BIGGER_CLOSE_BUTTON_DIAMETER}px;
		left: auto;
		top: ${SPLASH_TECH_BIGGER_CLOSE_BUTTON_TOP};
		right: ${SPLASH_TECH_BIGGER_CLOSE_BUTTON_RIGHT};
	}
	@media (min-width: ${props => `${calculateMinWidthWithMultiplier(props)}px`}) {
		right: calc(((100% - 1280px) / 2) + 25px);
	}
	& svg {
		fill: var(--thunderbite-close);
	}
`;

export const CloseButtonThunderbite = styled(Effect)`
	position: absolute;
	top: ${THUNDERBITE_SMALLER_CLOSE_BUTTON_TOP_LEFT}px;
	left: ${THUNDERBITE_SMALLER_CLOSE_BUTTON_TOP_LEFT}px;
	background-color: var(--thunderbite-modal-bg);
	width: ${THUNDERBITE_SMALLER_CLOSE_BUTTON_DIAMETER}px;
	height: ${THUNDERBITE_SMALLER_CLOSE_BUTTON_DIAMETER}px;
	border-radius: 9999px;
	display: flex;
	justify-content: center;
	align-items: center;
	${breakpoint.lg`
		width: ${THUNDERBITE_BIGGER_CLOSE_BUTTON_DIAMETER}px;
		height: ${THUNDERBITE_BIGGER_CLOSE_BUTTON_DIAMETER}px;
		top: ${THUNDERBITE_BIGGER_CLOSE_BUTTON_TOP_LEFT}px;
		left: ${THUNDERBITE_BIGGER_CLOSE_BUTTON_TOP_LEFT}px;
	`}
	& svg {
		fill: var(--thunderbite-close);
	}
`;
